module.exports = "/_next/static/images/CollectDataTabs-3@2x-e62dcebede83ddfd4b676c73952776cc.png";